import CustomModalLayoutV2 from "../../../bidder/Tabs/auctionFloor/components/CustomModalLayoutV2";

export function PDAcknowledgmentModal({
  acknowledgementOpen,
  setAcknowledgementOpen,
  errorMessage,
  onClose = () => {},
}: {
  acknowledgementOpen: boolean;
  setAcknowledgementOpen: React.Dispatch<React.SetStateAction<boolean>>;
  errorMessage?: string;
  onClose?: () => void;
}) {
  return (
    <div>
      <CustomModalLayoutV2
        open={acknowledgementOpen}
        onClose={() => {
          setAcknowledgementOpen(false);
          onClose?.();
        }}
        blurBackground={true}
        className="!w-full mx-2 sm:mx-4 md:mx-6 max-w-[580px] max-h-[95vh] sm:max-h-[90vh] overflow-hidden"
        childrenClassName="py-4 px-0 overflow-hidden flex flex-col"
      >
        {errorMessage ? (
          <p className="mt-2 font-openSans text-red-500 text-sm">
            {errorMessage}
          </p>
        ) : (
          <p className="mt-2 font-openSans text-[#717272] text-sm p-7">
            Your request has been recorded. Our customer support executive will
            contact you for more details.
          </p>
        )}
      </CustomModalLayoutV2>
    </div>
  );
}
